import { Controller } from "@hotwired/stimulus"
import axios from "axios"

export default class extends Controller {
  static targets = ["list", "input"]
  static values = {
    parentUrl: String,
    url: String
  }

  connect() {
    // zewnętrzny trigger (pozycja "Dodaj listę TODO" w menu "Dodaj" zadania) - listener na document,
    // bo window.Stimulus nadpisuje bundle modułu (np. index_organize) własną instancją aplikacji
    // i getControllerForElementAndIdentifier z inline onclick nie widzi tego kontrolera
    this.openHandler = (event) => {
      if (isTodoOpenTrigger(event.target)) this.showAndFocus()
    }
    document.addEventListener("click", this.openHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.openHandler)
  }

  checkBoxChanged(event) {
    const url = event.target.dataset.url
    console.log(url)
    axios.patch(url, JSON.stringify({
      todo: {
        closed: event.target.checked
      }
    }), {
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
  }

  // potwierdzenie usunięcia tylko dla niezaznaczonych (otwartych) TODO
  confirmDelete(event) {
    const li = event.target.closest("li")
    const checkbox = li?.querySelector("input[type=checkbox]")
    if (checkbox && !checkbox.checked) {
      const message = event.params.confirmMessage
      if (!confirm(message)) {
        event.preventDefault()
      }
    }
  }

  addTodo(_event) {
    // dajemy chwile turbo do przetworzenia formularza
    setTimeout(() => {
      this.inputTarget.value = ""
    }, 100)
  }

  // Pokazuje sekcję TODO, przewija i ustawia fokus
  showAndFocus() {
    // pokaż ukrytą sekcję (rodzic z data-toggle-target)
    const section = this.element.closest("[data-toggle-target=item1]")
    if (section) section.classList.remove("hidden")

    this.element.scrollIntoView({ behavior: "smooth", block: "center" })
    setTimeout(() => this.inputTarget.focus(), 300)
  }
}

// Czy kliknięty element to trigger otwarcia listy TODO (atrybut data-todo-open na nim lub przodku)
export function isTodoOpenTrigger(target) {
  return Boolean(target?.closest?.("[data-todo-open]"))
}
